import { FlatFileTransform, ValidationErrorBody } from '@cumu/shared';
import { displayServerValidationError } from './forms/validation';

export interface ExcelInstruction {
  arrayBuffer: ArrayBuffer;
  lowerCaseKeys: boolean;
  transform?: FlatFileTransform;
}

export async function readExcelFile(
  arrayBuffer: ArrayBuffer,
  name: string,
  form: HTMLFormElement,
  lowerCaseKeys = false,
  transform?: FlatFileTransform
): Promise<{ error: true } | { error: false; data: unknown[] }> {
  const worker = new Worker(new URL('./excel-worker.ts', import.meta.url), {
    type: 'module'
  });
  await new Promise<MessageEvent>(resolve =>
    worker.addEventListener('message', resolve, { once: true })
  );
  const instruction: ExcelInstruction = {
    arrayBuffer: await arrayBuffer,
    lowerCaseKeys,
    transform
  };
  worker.postMessage(instruction);
  const event = await new Promise<
    MessageEvent<
      { type: 'xlsx-error' } | { type: 'xlsx-data'; data: unknown[] }
    >
  >(resolve => worker.addEventListener('message', resolve, { once: true }));
  worker.terminate();
  if (event.data.type === 'xlsx-error') {
    const error: Omit<ValidationErrorBody, 'code'> = {
      type: 'validation-error',
      message: `Error opening "${name}". Ensure the file is a valid Excel file.`
    };
    displayServerValidationError(form, error);
    return { error: true };
  }
  return { error: false, data: event.data.data };
}
